import React, { useEffect, useState } from 'react';
import { adminGetClients, adminGetTierAudit, adminSetElite } from '../../api';

// ─── Dark-theme styles ──────────────────────────────────────────────────────
const s = {
    page:   { minHeight: 'calc(100vh - 52px)', background: '#0a0e1a', color: '#e2e8f0', padding: '28px 32px', margin: '-24px', borderRadius: 0 },
    h1:     { fontSize: 22, fontWeight: 700, marginBottom: 4, color: '#f1f5f9' },
    sub:    { color: '#64748b', fontSize: 13, marginBottom: 24 },
    cards:  { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 28 },
    card:   { background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 10, padding: '20px 24px' },
    cardN:  { fontSize: 28, fontWeight: 800 },
    cardL:  { fontSize: 12, color: '#64748b', marginTop: 4, textTransform: 'uppercase', letterSpacing: 0.5 },
    filter: { display: 'flex', gap: 10, marginBottom: 14, flexWrap: 'wrap', alignItems: 'center' },
    sel:    { padding: '8px 12px', border: '1px solid rgba(255,255,255,0.12)', borderRadius: 8, fontSize: 13, background: 'rgba(255,255,255,0.05)', color: '#e2e8f0' },
    inp:    { padding: '8px 12px', border: '1px solid rgba(255,255,255,0.12)', borderRadius: 8, fontSize: 13, background: 'rgba(255,255,255,0.05)', color: '#e2e8f0', width: 180 },
    panel:  { background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 10, overflow: 'auto' },
    table:  { width: '100%', borderCollapse: 'collapse', fontSize: 12, whiteSpace: 'nowrap' },
    th:     { textAlign: 'left', padding: '10px 12px', background: 'rgba(255,255,255,0.04)', borderBottom: '1px solid rgba(255,255,255,0.08)', color: '#94a3b8', fontSize: 10, textTransform: 'uppercase', letterSpacing: 0.5, fontWeight: 700 },
    td:     { padding: '9px 12px', borderBottom: '1px solid rgba(255,255,255,0.04)', verticalAlign: 'middle', color: '#cbd5e1' },
    trHover:{ background: 'rgba(255,255,255,0.02)' },
    btn:    { padding: '5px 12px', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 11, fontWeight: 600, background: '#6366f1', color: '#fff' },
    btnSm:  { padding: '4px 10px', border: '1px solid rgba(255,255,255,0.15)', borderRadius: 5, cursor: 'pointer', fontSize: 11, fontWeight: 600, background: 'transparent', color: '#e2e8f0' },
    link:   { color: '#818cf8', textDecoration: 'none', fontSize: 12, fontWeight: 600, cursor: 'pointer' },
    // Modal
    overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 },
    modal:   { background: '#1e2235', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 14, padding: '28px 32px', maxWidth: 420, width: '90%', boxShadow: '0 16px 48px rgba(0,0,0,0.4)' },
    mTitle:  { fontSize: 18, fontWeight: 700, color: '#f1f5f9', marginBottom: 4 },
    mSub:    { fontSize: 13, color: '#64748b', marginBottom: 20 },
    mLabel:  { fontSize: 12, fontWeight: 600, color: '#94a3b8', marginBottom: 6, marginTop: 16 },
    mInput:  { width: '100%', padding: '8px 12px', border: '1px solid rgba(255,255,255,0.15)', borderRadius: 8, fontSize: 13, boxSizing: 'border-box', background: 'rgba(255,255,255,0.05)', color: '#e2e8f0' },
    mBtnRow: { display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 24 },
    mBtnCancel:  { padding: '10px 20px', border: '1px solid rgba(255,255,255,0.15)', borderRadius: 8, background: 'transparent', cursor: 'pointer', fontSize: 13, fontWeight: 600, color: '#94a3b8' },
    mBtnConfirm: { padding: '10px 20px', border: 'none', borderRadius: 8, background: '#6366f1', color: '#fff', cursor: 'pointer', fontSize: 13, fontWeight: 600 },
};

const TIER_COLORS = {
    reseller: { bg: '#064e3b', color: '#6ee7b7' },
    partner:  { bg: '#3b0764', color: '#c084fc' },
    elite:    { bg: '#78350f', color: '#fbbf24' },
};

const tierBadge = (tier) => {
    const t = TIER_COLORS[tier] || { bg: '#1e293b', color: '#94a3b8' };
    return {
        display: 'inline-block', padding: '2px 8px', borderRadius: 12, fontSize: 10, fontWeight: 700,
        background: t.bg, color: t.color, textTransform: 'uppercase',
    };
};

function fmtDate(val) {
    if (!val) return '\u2014';
    const d = new Date(val);
    return d.toLocaleDateString('en-GB');
}

function fmtMoney(val) {
    const n = parseFloat(val || 0);
    return '\u20ac' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export default function AdminTiers() {
    const [clients, setClients]       = useState([]);
    const [auditLog, setAuditLog]     = useState([]);
    const [loading, setLoading]       = useState(true);
    const [filterTier, setFilterTier] = useState('all');
    const [search, setSearch]         = useState('');
    const [showAudit, setShowAudit]   = useState(false);
    const [auditLoading, setAuditLoading] = useState(false);

    // Set Elite modal
    const [eliteModal, setEliteModal] = useState(null); // client object or null
    const [eliteDiscount, setEliteDiscount] = useState('');
    const [saving, setSaving]         = useState(false);
    const [hoveredRow, setHoveredRow] = useState(null);

    const load = () => {
        setLoading(true);
        adminGetClients()
            .then(r => {
                const data = Array.isArray(r.data) ? r.data : [];
                setClients(data);
            })
            .catch(() => {})
            .finally(() => setLoading(false));
    };
    useEffect(load, []);

    const loadAudit = () => {
        setAuditLoading(true);
        adminGetTierAudit()
            .then(r => setAuditLog(Array.isArray(r.data) ? r.data : []))
            .catch(() => {})
            .finally(() => { setAuditLoading(false); setShowAudit(true); });
    };

    // Filter to reseller clients only (those with a tier)
    const resellers = clients.filter(c => c.is_reseller || c.tier);

    // Stats
    const totalResellers = resellers.filter(c => c.tier === 'reseller').length;
    const totalPartners  = resellers.filter(c => c.tier === 'partner').length;
    const totalElite     = resellers.filter(c => c.tier === 'elite').length;
    const monthlyRevenue = resellers.reduce((sum, c) => sum + parseFloat(c.monthly_volume || 0), 0);

    // Filtered + searched list
    const filtered = resellers
        .filter(c => filterTier === 'all' || c.tier === filterTier)
        .filter(c => {
            if (!search) return true;
            const q = search.toLowerCase();
            return (c.username || '').toLowerCase().includes(q) || String(c.id) === q;
        })
        .sort((a, b) => parseFloat(b.monthly_volume || 0) - parseFloat(a.monthly_volume || 0));

    // Set Elite action
    const handleSetElite = async () => {
        if (!eliteModal) return;
        const disc = parseFloat(eliteDiscount);
        if (isNaN(disc) || disc < 0 || disc > 100) {
            alert('Enter a valid discount (0-100)');
            return;
        }
        setSaving(true);
        try {
            await adminSetElite(eliteModal.id, { discount: disc });
            setEliteModal(null);
            setEliteDiscount('');
            load();
        } catch (e) {
            alert(e.response?.data?.error || 'Error setting elite');
        } finally {
            setSaving(false);
        }
    };

    return (
        <div style={s.page}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
                <div>
                    <h1 style={s.h1}>Tier Management</h1>
                    <p style={s.sub}>Reseller tiers, discounts and volume tracking</p>
                </div>
                <button style={s.btn} onClick={loadAudit}>
                    {auditLoading ? 'Loading...' : 'View Audit Log'}
                </button>
            </div>

            {/* ─── Stats Cards ────────────────────────────────────────── */}
            <div style={s.cards}>
                <div style={s.card}>
                    <div style={{ ...s.cardN, color: '#6ee7b7' }}>{totalResellers}</div>
                    <div style={s.cardL}>Resellers</div>
                </div>
                <div style={s.card}>
                    <div style={{ ...s.cardN, color: '#c084fc' }}>{totalPartners}</div>
                    <div style={s.cardL}>Partners</div>
                </div>
                <div style={s.card}>
                    <div style={{ ...s.cardN, color: '#fbbf24' }}>{totalElite}</div>
                    <div style={s.cardL}>Elite</div>
                </div>
                <div style={s.card}>
                    <div style={{ ...s.cardN, color: '#818cf8' }}>{fmtMoney(monthlyRevenue)}</div>
                    <div style={s.cardL}>Monthly Revenue</div>
                </div>
            </div>

            {/* ─── Filters ────────────────────────────────────────────── */}
            <div style={s.filter}>
                <select style={s.sel} value={filterTier} onChange={e => setFilterTier(e.target.value)}>
                    <option value="all">All Tiers</option>
                    <option value="reseller">Reseller</option>
                    <option value="partner">Partner</option>
                    <option value="elite">Elite</option>
                </select>
                <input
                    style={s.inp}
                    placeholder="Search username or ID..."
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                />
                <span style={{ color: '#64748b', fontSize: 12, marginLeft: 8 }}>
                    {filtered.length} reseller{filtered.length !== 1 ? 's' : ''}
                </span>
            </div>

            {/* ─── Table ──────────────────────────────────────────────── */}
            <div style={s.panel}>
                {loading ? (
                    <div style={{ padding: 40, textAlign: 'center', color: '#64748b' }}>Loading...</div>
                ) : (
                    <div className="og-table-wrap">
                    <table style={s.table}>
                        <thead>
                            <tr>
                                <th style={s.th}>Username</th>
                                <th style={s.th}>Tier</th>
                                <th style={s.th}>Discount %</th>
                                <th style={s.th}>Volume 30d</th>
                                <th style={s.th}>Volume 7d</th>
                                <th style={s.th}>Months Below</th>
                                <th style={s.th}>Early Partner</th>
                                <th style={s.th}>Tier Lock</th>
                                <th style={s.th}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filtered.length === 0 ? (
                                <tr>
                                    <td colSpan={9} style={{ ...s.td, textAlign: 'center', padding: 32, color: '#64748b' }}>
                                        No resellers found
                                    </td>
                                </tr>
                            ) : filtered.map(c => (
                                <tr
                                    key={c.id}
                                    style={hoveredRow === c.id ? s.trHover : undefined}
                                    onMouseEnter={() => setHoveredRow(c.id)}
                                    onMouseLeave={() => setHoveredRow(null)}
                                >
                                    <td style={s.td}>
                                        <span style={{ fontWeight: 600, color: '#f1f5f9' }}>{c.username}</span>
                                        <span style={{ color: '#475569', marginLeft: 6, fontSize: 11 }}>#{c.id}</span>
                                    </td>
                                    <td style={s.td}>
                                        <span style={tierBadge(c.tier)}>{c.tier || 'none'}</span>
                                    </td>
                                    <td style={s.td}>{c.discount_pct != null ? c.discount_pct + '%' : '\u2014'}</td>
                                    <td style={s.td}>{fmtMoney(c.monthly_volume)}</td>
                                    <td style={s.td}>{fmtMoney(c.weekly_volume)}</td>
                                    <td style={s.td}>
                                        <span style={{ color: (c.months_below_threshold || 0) >= 2 ? '#f87171' : '#94a3b8' }}>
                                            {c.months_below_threshold || 0}
                                        </span>
                                    </td>
                                    <td style={s.td}>
                                        {c.early_partner_until
                                            ? <span style={{ color: '#a78bfa', fontSize: 11 }}>Active until {fmtDate(c.early_partner_until)}</span>
                                            : '\u2014'
                                        }
                                    </td>
                                    <td style={s.td}>
                                        {c.tier_locked
                                            ? <span style={{ color: '#fbbf24', fontSize: 11, fontWeight: 600 }}>Locked</span>
                                            : <span style={{ color: '#475569', fontSize: 11 }}>No</span>
                                        }
                                    </td>
                                    <td style={s.td}>
                                        <button
                                            style={{ ...s.btnSm, borderColor: '#fbbf24', color: '#fbbf24' }}
                                            onClick={() => { setEliteModal(c); setEliteDiscount(c.discount_pct || ''); }}
                                        >
                                            Set Elite
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    </div>
                )}
            </div>

            {/* ─── Set Elite Modal ────────────────────────────────────── */}
            {eliteModal && (
                <div style={s.overlay} onClick={() => setEliteModal(null)}>
                    <div style={s.modal} onClick={e => e.stopPropagation()}>
                        <div style={s.mTitle}>Set Elite Tier</div>
                        <div style={s.mSub}>
                            Promote <strong style={{ color: '#f1f5f9' }}>{eliteModal.username}</strong> to Elite tier with a custom discount.
                        </div>
                        <label style={s.mLabel}>Discount %</label>
                        <input
                            style={s.mInput}
                            type="number"
                            min="0"
                            max="100"
                            placeholder="e.g. 15"
                            value={eliteDiscount}
                            onChange={e => setEliteDiscount(e.target.value)}
                            autoFocus
                        />
                        <div style={{ marginTop: 12, fontSize: 12, color: '#64748b' }}>
                            Current tier: <span style={tierBadge(eliteModal.tier)}>{eliteModal.tier || 'none'}</span>
                            {' '} | Current discount: {eliteModal.discount_pct != null ? eliteModal.discount_pct + '%' : 'none'}
                        </div>
                        <div style={s.mBtnRow}>
                            <button style={s.mBtnCancel} onClick={() => setEliteModal(null)}>Cancel</button>
                            <button
                                style={{ ...s.mBtnConfirm, background: '#d97706', opacity: saving ? 0.6 : 1 }}
                                onClick={handleSetElite}
                                disabled={saving}
                            >
                                {saving ? 'Saving...' : 'Confirm Elite'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* ─── Audit Log Modal ────────────────────────────────────── */}
            {showAudit && (
                <div style={s.overlay} onClick={() => setShowAudit(false)}>
                    <div style={{ ...s.modal, maxWidth: 700, maxHeight: '80vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
                        <div style={s.mTitle}>Tier Audit Log</div>
                        <div style={s.mSub}>History of all tier changes</div>
                        {auditLog.length === 0 ? (
                            <div style={{ color: '#64748b', fontSize: 13, padding: '20px 0' }}>No audit entries found.</div>
                        ) : (
                            <table style={{ ...s.table, fontSize: 11 }}>
                                <thead>
                                    <tr>
                                        <th style={s.th}>Date</th>
                                        <th style={s.th}>Client</th>
                                        <th style={s.th}>From</th>
                                        <th style={s.th}>To</th>
                                        <th style={s.th}>Reason</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {auditLog.map((entry, i) => (
                                        <tr key={i}>
                                            <td style={s.td}>{fmtDate(entry.created_at)}</td>
                                            <td style={s.td}>{entry.username || entry.client_id}</td>
                                            <td style={s.td}><span style={tierBadge(entry.old_tier)}>{entry.old_tier || 'none'}</span></td>
                                            <td style={s.td}><span style={tierBadge(entry.new_tier)}>{entry.new_tier || 'none'}</span></td>
                                            <td style={{ ...s.td, whiteSpace: 'normal', maxWidth: 200 }}>{entry.reason || '\u2014'}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                        <div style={{ ...s.mBtnRow, marginTop: 16 }}>
                            <button style={s.mBtnCancel} onClick={() => setShowAudit(false)}>Close</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
